/**
 * Custom Result Component
 * Extends Ant Design Result with custom styling
 */

import { Result as AntResult, ResultProps } from 'antd';
import classNames from 'classnames';
import './CustomResult.scss';

export interface CustomResultProps extends ResultProps {
  /** Result variant */
  variant?: 'default' | 'card' | 'fullpage';
}

/**
 * CustomResult Component
 */
export const CustomResult: React.FC<CustomResultProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const resultClasses = classNames('custom-result', `custom-result--${variant}`, className);

  return <AntResult {...rest} className={resultClasses} />;
};

export default CustomResult;

